import React from 'react';
import ReactDOM from 'react-dom';
import './app/styles/index.scss';
import {Provider} from 'react-redux';
import store from './app/store/configureStore';
import App from './app/components/App';
// import history from './app/helpers/history';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from "react-router-dom";


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <App/>
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
